import { ListItem, ListItemIcon, Typography } from "@mui/material";
import {
  AutocompleteType,
  TextFieldType,
  DatePickerType,
} from "../../../../utilis/component/CustomFormElement";
import { FamilyHistoryCodeType } from "./type";
import dayjs from "dayjs";

type socialHistoryFormType = {
  icdCode: AutocompleteType;
  relation: AutocompleteType;
  description: TextFieldType;
  fromdate: DatePickerType;
  todate: DatePickerType;
  notes: TextFieldType;
};

export const socialHistoryForm: socialHistoryFormType = {
  icdCode: {
    element: "autocomplete",
    name: "icd",
    fieldProps: { label: "Icd code" },
    rules: { required: "Icd code Required" },
    autocompleteProps: {
      getOptionLabel: (option: FamilyHistoryCodeType) =>
        `${option.icdCode}`,
      isOptionEqualToValue: (
        option: FamilyHistoryCodeType,
        value: FamilyHistoryCodeType
      ) => option.icdId == value.icdId,
      renderOption: (props, option: FamilyHistoryCodeType) => (
        <ListItem {...props}>
          <ListItemIcon>
            <Typography color={"primary"}>{option.icdCode}</Typography>
          </ListItemIcon>
          <Typography>{option.icdName}</Typography>
        </ListItem>
      ),
    },
  },
  relation: {
    element: "autocomplete",
    name: "relation",
    fieldProps: { label: "Relation" },
    rules: { required: "Relation required" },
    autocompleteProps: {
      getOptionLabel: (option) => option.description,
      isOptionEqualToValue: (option, value) => option.id == value.id,
    },
  },
  description: {
    element: "input",
    name: "description",
    fieldProps: { label: "Description", type: "text" },
    rules: { required: false },
  },
  fromdate: {
    element: "datepicker",
    name: "fromdate",
    fieldProps: { label: "From Date", type: "date" },
    rules: { required: false },
    dateFormat: "DD-MM-YYYY",
    calenderProps:{maxDate:dayjs()}
  },
  todate: {
    element: "datepicker",
    name: "todate",
    fieldProps: { label: "To Date", type: "date" },
    rules: { required: false },
    dateFormat: "DD-MM-YYYY",
    calenderProps:{maxDate:dayjs()}
  },
  notes: {
    element: "input",
    name: "notes",
    fieldProps: { label: "Notes", type: "text", multiline: true },
    rules: { required: false },
  },
};
